import React, { useState } from 'react';
import { Box } from '@mui/material';
import ComplexetyLevel from './ComplexetyLevel';
import PrincipalCID from './PrincipalCID';
import Procedures from './Procedures';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../../Common/ChartsContainer';

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return (
                <ComplexetyLevel
                    module={{
                        sectionTitle: 'do Total de Atendimentos'
                    }}
                    queryConfig={{
                        key: 'complexity-level-services',
                        url: 'governanceroom/dashboard/services/stratify/complexity'
                    }}
                />
            );
        case 1:
            return <Procedures />;
        case 2:
            return <PrincipalCID />;
        default:
            return null;
    }
};

const titleMap = {
    [`0`]: 'Nível de Complexidade',
    [`1`]: 'Procedimentos',
    [`2`]: 'CID Principal'
};

const Stratification = ({ setActiveIndex }) => {
    const [activeIndexLocal, setActiveIndexLocal] = useState(0);

    const handleHomeClick = () => {
        if (setActiveIndex) {
            setActiveIndex(0);
        }
        setActiveIndexLocal(0);
    };

    const menus = [
        {
            title: 'Nível de Complexidade',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndexLocal === 0
        },
        {
            title: 'Procedimentos',
            onclick: () => setActiveIndexLocal(1),
            active: activeIndexLocal === 1
        },
        {
            title: 'CID Principal',
            onclick: () => setActiveIndexLocal(2),
            active: activeIndexLocal === 2
        }
    ];

    return (
        <Box className="estratificacao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[`${activeIndexLocal}`]}
                    className={`services-container-dashboards`}
                >
                    {renderContent(activeIndexLocal)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Stratification;
